export default class {
    _id;
    _executorEditStrategy;
    _shipmentDeliveryDateStrategy;
    _executorCreateInvoiceStrategy;
    _shipmentDateMethodStrategy;
    _productNameDefineMethodStrategy;
    _contractDefineMethodStrategy;
    _itemQuantityLimitStrategy;
    _customerInn;
    _customerName;
    _executorInn;
    _executorName;
    _number;
    _date;
    _contractNumber;
    _contractDate;
    _expiresOn;
    _deliveryAddress;
    _branch;
    _createdOn;
    _isCustomerApproved;
    _customerApprovedOn;
    _isExecutorApproved;
    _executorApprovedOn;
    _isExecutorDeclined;
    _executorDeclinedOn;
    _isReturn;
    _returnNumber;
    _returnDate;
    _returnInvoiceId;
    _returnInvoiceNumber;
    _returnInvoiceDate;
    _isReturnInvoiceExecutorApproved;
    _isReturnInvoiceCustomerApproved;
    _isStopped;
    _stoppedOn;
    _status;
    _customerSystemId;
    _customerShipmentId;



    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get executorEditStrategy() {
        return this._executorEditStrategy
    }

    set executorEditStrategy(value) {
        this._executorEditStrategy = value
    }

    get shipmentDeliveryDateStrategy() {
        return this._shipmentDeliveryDateStrategy
    }

    set shipmentDeliveryDateStrategy(value) {
        this._shipmentDeliveryDateStrategy = value
    }

    get executorCreateInvoiceStrategy() {
        return this._executorCreateInvoiceStrategy
    }

    set executorCreateInvoiceStrategy(value) {
        this._executorCreateInvoiceStrategy = value
    }

    get shipmentDateMethodStrategy() {
        return this._shipmentDateMethodStrategy
    }

    set shipmentDateMethodStrategy(value) {
        this._shipmentDateMethodStrategy = value
    }

    get productNameDefineMethodStrategy() {
        return this._productNameDefineMethodStrategy
    }

    set productNameDefineMethodStrategy(value) {
        this._productNameDefineMethodStrategy = value
    }

    get contractDefineMethodStrategy() {
        return this._contractDefineMethodStrategy
    }

    set contractDefineMethodStrategy(value) {
        this._contractDefineMethodStrategy = value
    }

    get itemQuantityLimitStrategy() {
        return this._itemQuantityLimitStrategy
    }

    set itemQuantityLimitStrategy(value) {
        this._itemQuantityLimitStrategy = value
    }

    get customerInn() {
        return this._customerInn
    }

    set customerInn(value) {
        this._customerInn = value
    }

    get customerName() {
        return this._customerName
    }

    set customerName(value) {
        this._customerName = value
    }

    get executorInn() {
        return this._executorInn
    }

    set executorInn(value) {
        this._executorInn = value
    }

    get executorName() {
        return this._executorName
    }

    set executorName(value) {
        this._executorName = value
    }

    get number() {
        return this._number
    }

    set number(value) {
        this._number = value
    }

    get date() {
        return this._date
    }

    set date(value) {
        this._date = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }

    get contractDate() {
        return this._contractDate
    }

    set contractDate(value) {
        this._contractDate = value
    }

    get expiresOn() {
        return this._expiresOn
    }

    set expiresOn(value) {
        this._expiresOn = value
    }

    get deliveryAddress() {
        return this._deliveryAddress
    }

    set deliveryAddress(value) {
        this._deliveryAddress = value
    }

    get branch() {
        return this._branch
    }

    set branch(value) {
        this._branch = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get isCustomerApproved() {
        return this._isCustomerApproved
    }

    set isCustomerApproved(value) {
        this._isCustomerApproved = value
    }

    get customerApprovedOn() {
        return this._customerApprovedOn
    }

    set customerApprovedOn(value) {
        this._customerApprovedOn = value
    }

    get isExecutorApproved() {
        return this._isExecutorApproved
    }

    set isExecutorApproved(value) {
        this._isExecutorApproved = value
    }

    get executorApprovedOn() {
        return this._executorApprovedOn
    }

    set executorApprovedOn(value) {
        this._executorApprovedOn = value
    }

    get isExecutorDeclined() {
        return this._isExecutorDeclined
    }

    set isExecutorDeclined(value) {
        this._isExecutorDeclined = value
    }

    get executorDeclinedOn() {
        return this._executorDeclinedOn
    }

    set executorDeclinedOn(value) {
        this._executorDeclinedOn = value
    }

    get isReturn() {
        return this._isReturn
    }

    set isReturn(value) {
        this._isReturn = value
    }

    get returnNumber() {
        return this._returnNumber
    }

    set returnNumber(value) {
        this._returnNumber = value
    }

    get returnDate() {
        return this._returnDate
    }

    set returnDate(value) {
        this._returnDate = value
    }

    get returnInvoiceId() {
        return this._returnInvoiceId
    }

    set returnInvoiceId(value) {
        this._returnInvoiceId = value
    }

    get returnInvoiceNumber() {
        return this._returnInvoiceNumber
    }

    set returnInvoiceNumber(value) {
        this._returnInvoiceNumber = value
    }

    get returnInvoiceDate() {
        return this._returnInvoiceDate
    }

    set returnInvoiceDate(value) {
        this._returnInvoiceDate = value
    }

    get isReturnInvoiceExecutorApproved() {
        return this._isReturnInvoiceExecutorApproved
    }

    set isReturnInvoiceExecutorApproved(value) {
        this._isReturnInvoiceExecutorApproved = value
    }

    get isReturnInvoiceCustomerApproved() {
        return this._isReturnInvoiceCustomerApproved
    }

    set isReturnInvoiceCustomerApproved(value) {
        this._isReturnInvoiceCustomerApproved = value
    }

    get isStopped() {
        return this._isStopped
    }

    set isStopped(value) {
        this._isStopped = value
    }

    get stoppedOn() {
        return this._stoppedOn
    }

    set stoppedOn(value) {
        this._stoppedOn = value
    }

    get status() {
        return this._status
    }

    set status(value) {
        this._status = value
    }

    get customerSystemId() {
        return this._customerSystemId
    }

    set customerSystemId(value) {
        this._customerSystemId = value
    }

    get customerShipmentId() {
        return this._customerShipmentId
    }

    set customerShipmentId(value) {
        this._customerShipmentId = value
    }



    // computed
    get isAllApproved() {
        return this.isCustomerApproved && this.isExecutorApproved
    }
}